import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import { popUpMenuChange,
        selectedCardsGroupsChange,
        popUpMessageChange,
        deletedCardsGroupsChange } from '../../actions/index'

import Icon from '@mdi/react';
import { mdiBackupRestore } from '@mdi/js';

import { _ } from '../../functions/translator'
import { showMessage } from '../../functions/popUpMessage';


class StandByButton extends React.Component{
          
    handleClick = async () => {
        let count = this.props.cardsGroupIds.length
        let message = '¿' + _('Estás seguro de dejar en pendiente') + ' ' + count + ' '
        message += count > 1 ? _('protocolos') : _('protocolo')
        message += '?'
        const messageConfig = {
            closeButton: true,
            standByConfirmation: true,
            cardsGroupIds: this.props.cardsGroupIds
        };
        showMessage(this.props, message, messageConfig);
        this.props.popUpMenuChange({ show: false })
        this.props.selectedCardsGroupsChange([])
    }

    render(){   
        
        return (
            <div>
                <div className="popup-menu-button card-color" ref={ref => this.button = ref } onClick={this.handleClick}>
                    <div className='d-inline-flex'>
                        <Icon path={ mdiBackupRestore } size='30px' color='white' style={{margin: 10}}/>
                        <p>{ _('Devolver a Pendiente(s)') }</p>
                    </div>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        popUpMenu : state.popUpMenu,
        userRole  : state.userRole,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({
        popUpMenuChange : popUpMenuChange,
        selectedCardsGroupsChange : selectedCardsGroupsChange,
        popUpMessageChange : popUpMessageChange,
        deletedCardsGroupsChange : deletedCardsGroupsChange
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(StandByButton)